import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import ArticlePromo from './components/ArticlePromo';
import PillarArticles from './components/PillarArticles';
import Faq from './components/Faq';
import { useSeo, FAVICON_URL } from '@/lib/seo';
import { useJsonLd, buildWebSiteSchema, buildOrganizationSchema } from '@/lib/schema';

export default function Home() {
  useSeo({
    title: 'AllChinaBuy Spreadsheet | Find Products, Links & QC Picks Faster',
    description:
      'AllChinaBuy Spreadsheet is an independent resource for the latest product finds, links, QC photos, buying guides and shipping tips. Browse shoes, hoodies, t-shirts, jackets and more organized by category.',
    ogDescription:
      'Explore the latest AllChinaBuy spreadsheet resources, product finds, links, QC info and shipping guides in one organized place.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy links, AllChinaBuy finds, AllChinaBuy QC, AllChinaBuy review, AllChinaBuy shipping cost',
    path: '/',
    image: FAVICON_URL,
  });

  useJsonLd([buildWebSiteSchema(), buildOrganizationSchema()]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <InfoSections />
        <ArticlePromo />
        <PillarArticles />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}